module.exports = __webpack_public_path__ + "img/portret.3520b239.jpg";